import instance from "axios";
const cancelToken = instance.CancelToken;
const source = cancelToken.source();
const axiosInstance = instance.create({
  cancelToken: source.token,
});

axiosInstance.interceptors.request.use((config) => {
  const token = {
    access_token: localStorage.getItem("access_token"),
  };
  const defaultHeaders = {
    "api-version": "1.0",
    "content-type": "application/json",
    "Access-Control-Allow-Credentials": "true",
    "Access-Control-Allow-Methods": "GET, POST,PUT, OPTIONS",
    "Access-Control-Allow-Headers": "Origin, Content-Type, Accept",
  };
  if (token.access_token) {
    config.headers = {
      ...defaultHeaders,
      Authorization: `Bearer ${token.access_token}`,
    };
  }
  
  else {
    config.headers = defaultHeaders;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response;
    if (status === 401 || status === 500) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("isAuthenticated");
      //default
      window.location = "/";
    }
    if (status === 403) {
      return {
        status: 200,
        data: { success: false, message: "You can not perform this action." },
      };
    }
  }
);

export const axios = axiosInstance;
